/**
 * Bridge Message Operations
 * Shared constants for sidebar <-> dialog communication.
 * Both sidebarBridge.js and dialogBridge.js import from here.
 */

/** Operation types for bridge requests */
export const OPS = {
  /** Health check */
  PING: "PING",
  /** Dialog signals it is ready to receive messages */
  READY: "READY",
  /** Dialog requests current crypto state from sidebar */
  GET_STATE: "GET_STATE",
  /** Dialog asks sidebar to unlock with a password */
  UNLOCK_REQUEST: "UNLOCK_REQUEST",
  /** Dialog asks sidebar to clear crypto state */
  LOCK_REQUEST: "LOCK_REQUEST",
  /** Dialog sends encrypted entries for sidebar to decrypt */
  DECRYPT_MANY: "DECRYPT_MANY",
  /** Dialog sends plaintext entries for sidebar to encrypt */
  ENCRYPT_MANY: "ENCRYPT_MANY",
  /** Dialog asks sidebar to decrypt all passwords and match by recipients */
  DECRYPT_PREFILL: "DECRYPT_PREFILL",
  /** Dialog asks sidebar to decrypt MasterKey for a (possibly new) active DB */
  DECRYPT_MASTER_KEY: "DECRYPT_MASTER_KEY",
  /** Dialog asks sidebar to encrypt a new MasterKey with the user's public key */
  ENCRYPT_NEW_MASTER_KEY: "ENCRYPT_NEW_MASTER_KEY",
};

/** Message source tag – prevents processing unrelated messages */
export const MSG_SOURCE = "avamboo-encrypt-bridge";

/** Timeout for pending bridge requests (ms) */
export const REQUEST_TIMEOUT_MS = 45_000;
